import React, { memo } from 'react';
import classnames from 'classnames';
import './ImageBanner.scss';
import BrowserLink from '../../../../components/BrowserLink';
import AppLink from '../../../../components/AppLink';

export const ImageBanner = memo(function ImageBanner({
  banner: { img, image_mobile, url, react_route },
 ...props
}) {

  const wrapperClasses = 'ImageBanner';
  const content = (
    <>
      <img src={img} alt="" className={classnames('ImageBanner__img', { 'ImageBanner__img_desktop': image_mobile })} />
      {image_mobile && (
        <img src={image_mobile} alt="" className="ImageBanner__img ImageBanner__img_mobile" />
      )}
    </>
  );

  if(react_route) {
    return (
      <AppLink to={react_route} className={wrapperClasses} {...props}>
        {content}
      </AppLink>
    );
  }

  if(url) {
    return (
      <BrowserLink href={url} className={wrapperClasses} {...props}>
        {content}
      </BrowserLink>
    );
  }

  return (
    <div className={wrapperClasses} {...props}>
      {content}
    </div>
  );
});
